import { useRef } from "react";
import { t } from "../../translations";
import { Aa } from "../functions/Aa";
import "../styles/category-section.css";

import imgAll from "../../assets/all-food.png";

import { FaArrowAltCircleLeft, FaArrowAltCircleRight } from "react-icons/fa";

const ImgPlusText = (
  { name, eng_name, country_name, icon },
  lang,
  selectedCuisine,
  setCuisine
) => {
  return (
    <div
      className="img-plus-text"
      style={{
        borderBottomStyle: selectedCuisine === country_name ? "solid" : "none",
        borderBottomWidth: 3,
        borderBottomColor: "#FF114D"
      }}
      onClick={() => {
        setCuisine(country_name);
      }}
    >
      <img
        src={icon}
        alt="cat"
        style={{
          width: 50,
          height: 50
        }}
      />
      <h4>{Aa(lang === "fr" ? name : eng_name)}</h4>
    </div>
  );
};

const CategorySection = (props) => {
  const { list, lang, selectedCuisine, setCuisine } = props;
  const scrollContainerRef = useRef(null);

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollLeft -= 100; // Adjust the scroll distance as needed
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollLeft += 100; // Adjust the scroll distance as needed
    }
  };
  return (
    <div className="category-section">
      <div
        className="left-right-btn-scroll"
        onClick={() => {
          scrollLeft();
        }}
      >
        <FaArrowAltCircleLeft size={25} color={"#FF114D"} />
      </div>
      <div className="foodtype-block" ref={scrollContainerRef}>
        {[
          {
            name: t("category_section.all"),
            eng_name: t("category_section.all"),
            icon: imgAll,
            country_name: "all"
          },
          ...list
        ]?.map((item) => ImgPlusText(item, lang, selectedCuisine, setCuisine))}
      </div>
      <div
        className="left-right-btn-scroll"
        onClick={() => {
          scrollRight();
        }}
      >
        <FaArrowAltCircleRight size={25} color={"#FF114D"} />
      </div>
    </div>
  );
};

export default CategorySection;
